/// <amd-module name="Build/Admin/Pool/Components/PoolPipelineSecurity" />
import * as React from "react";

import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { Toggle } from "VSSUI/Toggle";

import { StoreStatus } from "Build/Admin/Common/Constants";

import * as Resources from "Build/Admin/Pool/Resources";

export interface IPoolPipelineSecurityProps {
    allPipelinesAuthorized: boolean;
    managePermission: boolean;
    status: StoreStatus;
    onSave(allPipelinesAuthorized: boolean): void;
}

export class PoolPipelineSecurity extends React.PureComponent<IPoolPipelineSecurityProps> {

    constructor(props: IPoolPipelineSecurityProps) {
        super(props);
    }

    public render(): JSX.Element {
        if (this.props.status === StoreStatus.Loaded) {
            return (
                <Toggle
                    onChange={this._onAuthorizeAllCheckboxChange}
                    checked={this.props.allPipelinesAuthorized}
                    disabled={!this.props.managePermission}
                    text={Resources.PipelineSecurityAuthorizeAll}
                />
            );
        }
        else {
            return (
                <Spinner className="flex-grow flex-self-center" size={SpinnerSize.large} />
            );
        }
    }

    private _onAuthorizeAllCheckboxChange = (ev: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement> , checked: boolean): void => {
        if (this.props.managePermission) {
            this.props.onSave(checked);
        }
    }
}
